import { render, staticRenderFns } from "./AppGeoPrzewodnik.vue?vue&type=template&id=76a92d2e&"
import script from "./AppGeoPrzewodnik.vue?vue&type=script&lang=js&"
export * from "./AppGeoPrzewodnik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports